// 导出TableHead 数据
export var GoodsTableHead = [{
  title: '图片',
  slot: 'image',
  align: 'center',
  minWidth: 60
}, {
  title: '兑换金额（元）',
  slot: 'price',
  align: 'center',
  minWidth: 120
}, {
  title: '兑换券',
  slot: 'redeemIntegral',
  align: 'center',
  minWidth: 100
}, {
  title: '批发价金额',
  slot: 'wholesalePrice',
  align: 'center',
  minWidth: 120
},
// {
//   title: '兑换券批发价',
//   slot: 'wholesaleIntegral',
//   align: 'center',
//   minWidth: 120,
// },
{
  title: '划线价',
  slot: 'cost',
  align: 'center',
  minWidth: 100
}, {
  title: '赠送福豆数量',
  slot: 'fuDouCount',
  align: 'center',
  minWidth: 120
}, {
  title: 'MES数量',
  slot: 'mesCount',
  align: 'center',
  minWidth: 120
}, {
  title: '库存',
  slot: 'stock',
  align: 'center',
  minWidth: 100
}, {
  title: '商品编码',
  slot: 'barCode',
  align: 'center',
  minWidth: 120
}, {
  title: '重量（KG）',
  slot: 'weight',
  align: 'center',
  minWidth: 90
}, {
  title: '体积(m³)',
  slot: 'volume',
  align: 'center',
  minWidth: 90
}, {
  title: '默认选中规格',
  slot: 'isDefault',
  fixed: 'right',
  align: 'center',
  minWidth: 100
}, {
  title: '操作',
  slot: 'action',
  fixed: 'right',
  align: 'center',
  minWidth: 100
}];